/*
  Nature Lane Beauty — quantity stepper.

  Replaces Dawn's <quantity-input>, which is not reusable without adopting its
  class names: validateQtyRules() does

      this.querySelector(".quantity__button[name='minus']").classList.toggle(...)

  and throws a TypeError on any markup that doesn't use `quantity__button`.
  Taking on Dawn's class names would also pull in Dawn's quantity styling, so
  this is a dozen lines instead.

  Emits a bubbling `change` on the input, which is what cart.js listens for in
  the cart drawer — so removal by stepping to zero keeps working.
*/
(function () {
  'use strict';

  class NlbQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input) return;

      this.querySelectorAll('button[data-nlb-step]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.step(button.dataset.nlbStep);
        });
      });
    }

    step(direction) {
      var min = parseInt(this.input.min, 10);
      if (isNaN(min)) min = 0;

      var max = this.input.max ? parseInt(this.input.max, 10) : Infinity;
      var current = parseInt(this.input.value, 10);
      if (isNaN(current)) current = min;

      var next = current + (direction === 'plus' ? 1 : -1);
      next = Math.min(max, Math.max(min, next));
      if (next === current) return;

      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('nlb-quantity')) {
    customElements.define('nlb-quantity', NlbQuantity);
  }
})();
